import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {Banner, BannerTypesEnum} from '../../../common/banners/banner';
import {BannerContent} from '../../../common/banners/bannerContent';
import {BannerContentTitle} from '../../../common/banners/bannerContentTitle';
import {BannerIcon} from '../../../common/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../common/banners/bannersContext';

/*
 * Props.
 */

interface ImpersonationModeBannerProps {
  isImpersonating: boolean;
}

/*
 * Component.
 */

export const ImpersonationModeBanner: FC<ImpersonationModeBannerProps> = (props) => {
  const theme = useUserTheme();
  if (!props.isImpersonating) {
    return null;
  }

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.red.shade40}
      priority={BannerPrioritiesEnum.ERROR}
    >
      <BannerIcon iconName="warningFilledSmall" />
      <BannerContent>
        <BannerContentTitle>
          <Trans id="impersonation-mode-title">Impersonation mode</Trans>
        </BannerContentTitle>
        <Trans id="impersonation-mode-text">
          This is not your own account! You are connected on behalf of the user.
        </Trans>
      </BannerContent>
    </Banner>
  );
};
